import { noop } from 'lodash';
import ErrorBoundary from 'components/ErrorBoundary';
import GridItemComponent from './GridItem/GridItem';
import { jsx as _jsx } from "react/jsx-runtime";

const ItemGrid = _ref => {
  let {
    items,
    renderItem,
    widthResolver = () => null,
    onItemVisible = noop,
    handleErrorLogging,
    preventLog
  } = _ref;
  const ItemComponent = renderItem;
  return /*#__PURE__*/_jsx("div", {
    className: "feed-grid",
    children: items.map((item, index) => /*#__PURE__*/_jsx(GridItemComponent, {
      width: widthResolver(item),
      onVisible: waypoint => onItemVisible({
        item,
        waypoint,
        index
      }),
      children: /*#__PURE__*/_jsx(ErrorBoundary, {
        FallbackComponent: ErrorBoundary.ComponentError,
        preventLog: preventLog,
        onError: handleErrorLogging,
        children: /*#__PURE__*/_jsx(ItemComponent, {
          item: item,
          index: index
        })
      })
    }, item.id))
  });
};

export default ItemGrid;